import { memo } from 'react';
import { OpeLegisVM, ChangeRelationshipVM } from 'mutation/view-models/registration-citizenship';
import { Grid, useEventCallback } from '@mui/material';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import ArticleList from '../shared/article-list';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import ChangeRelationship from '../shared/change-relationship';
import { ItemVM } from 'shell/view-models/item';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';

interface OpenLegisProps {
  values?: OpeLegisVM;
  onChange: (key: keyof OpeLegisVM, value: OpeLegisVM[keyof OpeLegisVM]) => void;
  idReason: string;
  isNationalSearch?: string;
  disabled?: boolean;
}

const OpeLegisComponent = ({
  onChange,
  values,
  idReason,
  isNationalSearch,
  disabled,
}: OpenLegisProps): React.ReactElement => {
  const onChangeArticleList = useEventCallback((value: ItemVM<MotArtCitizenship> | null) => {
    onChange('article', value);
  });

  const handleForeignStateListChange = useEventCallback(
    (citizenship: ForeignStateVM | null | undefined) => {
      onChange('otherCitizenship', citizenship);
    }
  );

  const onChangeValuesChangeRelationship = useEventCallback((value: ChangeRelationshipVM) => {
    onChange('changeRelationship', value);
  });

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Perdita cittadinanza italiana"
          aria-label="Perdita cittadinanza italiana"
          value={values?.dateLoss || null}
          onChange={(date) => {
            onChange('dateLoss', date);
          }}
          renderInput={(params) => (
            <PmiTextField id="dateLoss" {...params} fullWidth helperText="" disabled={disabled} />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <ForeignStateList
          label="Altra cittadinanza"
          aria-label="Altra cittadinanza"
          id="otherCitizenship"
          value={values?.otherCitizenship || null}
          onChange={handleForeignStateListChange}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <ArticleList
          value={values?.article?.id?.toString() || ''}
          onChange={onChangeArticleList}
          idReason={idReason}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <ChangeRelationship
          values={values?.changeRelationship}
          onChangeValues={onChangeValuesChangeRelationship}
          isNationalSearch={isNationalSearch}
        />
      </Grid>
    </Grid>
  );
};

OpeLegisComponent.displayName = 'Form Accordion Registration Citizenship - Ope Legis component';

const OpeLegis = memo(OpeLegisComponent);

export default OpeLegis;
